
// import React, { useState, useEffect } from "react";
// import {
//   Table,
//   Button,
//   Space,
//   Modal,
//   Form,
//   Input,
//   message,
//   Upload,
//   Spin,
// } from "antd";
// import { UploadOutlined, LoadingOutlined } from "@ant-design/icons";
// import axios from "axios";

// const { Search } = Input;

// const ManageServices = () => {
//   const [services, setServices] = useState([]);
//   const [modalState, setModalState] = useState({
//     isVisible: false,
//     editingService: null,
//   });
//   const [searchText, setSearchText] = useState("");
//   const [loading, setLoading] = useState(false); // 👈 Loader state
//   const [form] = Form.useForm();

//   useEffect(() => {
//     fetchServices();
//   }, []);

//   const fetchServices = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(
//         "http://localhost:4000/service/readAllService"
//       );
//       setServices(response.data.data.services || []);
//     } catch (error) {
//       console.error("Error fetching services:", error);
//       message.error("Failed to fetch services.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const uploadImageToCloudinary = async (file) => {
//     const CLOUD_NAME = "dmtwtt5mz";
//     const UPLOAD_PRESET = "provider_gallery_upload";

//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("upload_preset", UPLOAD_PRESET);

//     try {
//       const res = await axios.post(
//         `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
//         formData
//       );
//       return res.data.secure_url;
//     } catch (err) {
//       console.error("Cloudinary Upload Error", err);
//       return null;
//     }
//   };

//   const handleSave = async () => {
//     try {
//       const values = await form.validateFields();
//       const { editingService } = modalState;

//       setLoading(true); // 👈 Start loader

//       let imageUrl = editingService?.image || "";
//       const imageFile = values.image?.[0];

//       if (imageFile && imageFile.originFileObj) {
//         const uploadedUrl = await uploadImageToCloudinary(
//           imageFile.originFileObj
//         );
//         if (!uploadedUrl) {
//           message.error("Image upload failed.");
//           setLoading(false);
//           return;
//         }
//         imageUrl = uploadedUrl;
//       }

//       const payload = {
//         name: values.name,
//         description: values.description,
//         category: values.category,
//         image: imageUrl,
//       };

//       if (editingService) {
//         await axios.put(
//           `http://localhost:4000/service/updateService/${editingService._id}`,
//           payload
//         );
//         message.success("Service updated successfully");
//       } else {
//         await axios.post(
//           "http://localhost:4000/service/addService",
//           payload
//         );
//         message.success("Service added successfully");
//       }

//       fetchServices();
//       closeModal();
//     } catch (error) {
//       console.error("Save Error:", error);
//       message.error("Failed to save service.");
//     } finally {
//       setLoading(false); // 👈 Stop loader
//     }
//   };

//   const handleDelete = async (id) => {
//     try {
//       setLoading(true); // 👈 Start loader
//       await axios.delete(
//         `http://localhost:4000/service/deleteService/${id}`
//       );
//       message.success("Service deleted successfully");
//       fetchServices();
//     } catch (error) {
//       console.error("Delete Error:", error);
//       message.error("Failed to delete service.");
//     } finally {
//       setLoading(false); // 👈 Stop loader
//     }
//   };

//   const openModal = (service = null) => {
//     setModalState({ isVisible: true, editingService: service });
//     if (service) {
//       form.setFieldsValue({
//         name: service.name,
//         description: service.description,
//         category: service.category,
//         image: [
//           {
//             uid: "-1",
//             name: "existing-image.jpg",
//             status: "done",
//             url: service.image,
//           },
//         ],
//       });
//     } else {
//       form.resetFields();
//     }
//   };

//   const closeModal = () => {
//     setModalState({ isVisible: false, editingService: null });
//     form.resetFields();
//   };

//   const columns = [
//     {
//       title: "Service Name",
//       dataIndex: "name",
//       key: "name",
//     },
//     {
//       title: "Description",
//       dataIndex: "description",
//       key: "description",
//     },
//     {
//       title: "Category",
//       dataIndex: "category",
//       key: "category",
//     },
//     {
//       title: "Image",
//       dataIndex: "image",
//       key: "image",
//       render: (text) =>
//         text ? (
//           <img
//             src={text}
//             alt="Service"
//             style={{ width: "50px", borderRadius: "4px" }}
//           />
//         ) : (
//           "No Image"
//         ),
//     },
//     {
//       title: "Action",
//       key: "action",
//       render: (_, record) => (
//         <Space>
//           <Button onClick={() => openModal(record)}>Edit</Button>
//           <Button danger onClick={() => handleDelete(record._id)}>
//             Delete
//           </Button>
//         </Space>
//       ),
//     },
//   ];

//   // 👑 Premium loader icon
//   const antIcon = (
//     <LoadingOutlined
//       style={{ fontSize: 40, color: "#fa8c16" }}
//       spin
//     />
//   );

//   return (
//     <div className="p-4 bg-white rounded shadow">
//       <h2 className="text-xl mb-4">Manage Services</h2>

//       <Search
//         placeholder="Search services"
//         onChange={(e) => setSearchText(e.target.value)}
//         style={{ marginBottom: "1rem" }}
//       />

//       <Button
//         type="primary"
//         onClick={() => openModal()}
//         style={{ marginBottom: "1rem" }}
//       >
//         Add Service
//       </Button>

//       {/* Loader wrapper */}
//       <Spin
//         spinning={loading}
//         indicator={antIcon}
//         tip="Processing..."
//         size="large"
//       >
//         <Table
//           columns={columns}
//           dataSource={services.filter(
//             (s) =>
//               s.name.toLowerCase().includes(searchText.toLowerCase()) ||
//               s.description
//                 .toLowerCase()
//                 .includes(searchText.toLowerCase())
//           )}
//           rowKey="_id"
//           pagination={{ pageSize: 10 }}
//           scroll={{ x: "max-content", y: 500 }}
//           sticky
//         />
//       </Spin>

//       <Modal
//         title={modalState.editingService ? "Edit Service" : "Add Service"}
//         open={modalState.isVisible}
//         onCancel={closeModal}
//         onOk={handleSave}
//         destroyOnClose
//         confirmLoading={loading} // 👈 adds loader on modal OK button
//       >
//         <Form form={form} layout="vertical">
//           <Form.Item
//             name="name"
//             label="Service Name"
//             rules={[{ required: true, message: "Please enter a name" }]}
//           >
//             <Input />
//           </Form.Item>

//           <Form.Item
//             name="description"
//             label="Description"
//             rules={[{ required: true, message: "Please enter a description" }]}
//           >
//             <Input />
//           </Form.Item>

//           <Form.Item
//             name="category"
//             label="Category"
//             rules={[{ required: true, message: "Please enter a category" }]}
//           >
//             <Input placeholder="e.g. Cleaning, Repair, IT Support" />
//           </Form.Item>

//           <Form.Item
//             name="image"
//             label="Image"
//             valuePropName="fileList"
//             getValueFromEvent={(e) => e?.fileList || []}
//             rules={[
//               {
//                 required: !modalState.editingService,
//                 message: "Please upload an image!",
//               },
//             ]}
//           >
//             <Upload beforeUpload={() => false} listType="picture" maxCount={1}>
//               <Button icon={<UploadOutlined />}>Upload</Button>
//             </Upload>
//           </Form.Item>
//         </Form>
//       </Modal>
//     </div>
//   );
// };

// export default ManageServices;


// tt
import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Space,
  Modal,
  Form,
  Input,
  message,
  Upload,
  Spin,
  Select,
} from "antd";
import { UploadOutlined, LoadingOutlined } from "@ant-design/icons";
import axios from "axios";

const { Search } = Input;

const ManageServices = () => {
  const [services, setServices] = useState([]);
  const [modalState, setModalState] = useState({
    isVisible: false,
    editingService: null,
  });
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [form] = Form.useForm();

  const categoryOptions = [
    {
      label: "Blinds",
      value: "Blinds",
      subcategories: [
        "Vertical Blinds",
        "Roller Blinds",
        "Venetian Blinds",
        "Blockout Blinds",
        "Roman Blinds",
        "Electrical Blinds",
        "Perfect Fit Shutter",
        "Shutter",
      ],
    },
    {
      label: "Carpets",
      value: "Carpets",
      subcategories: ["Various quality carpets available"],
    },
    {
      label: "Furniture",
      value: "Furniture",
      subcategories: [
        "Single Bed",
        "Double Bed",
        "Ottoman Bed",
        "Mattress",
        "Rental Property Furniture",
      ],
    },
    {
      label: "Sofa Collection",
      value: "Sofa Collection",
      subcategories: ["Various Sofa Designs"],
    },
  ];

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE}/service/readAllService`);
      setServices(response.data.data.services || []);
    } catch (error) {
      console.error("Error fetching services:", error);
      message.error("Failed to fetch services.");
    } finally {
      setLoading(false);
    }
  };

  const uploadImageToCloudinary = async (file) => {
    const CLOUD_NAME = "dmtwtt5mz";
    const UPLOAD_PRESET = "provider_gallery_upload";

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);

    try {
      const res = await axios.post(
        `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
        formData
      );
      return res.data.secure_url;
    } catch (err) {
      console.error("Cloudinary Upload Error", err);
      return null;
    }
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const { editingService } = modalState;

      setLoading(true);

      let imageUrl = editingService?.image || "";
      const imageFile = values.image?.[0];

      if (imageFile && imageFile.originFileObj) {
        const uploadedUrl = await uploadImageToCloudinary(imageFile.originFileObj);
        if (!uploadedUrl) {
          message.error("Image upload failed.");
          setLoading(false);
          return;
        }
        imageUrl = uploadedUrl;
      }

      const payload = {
        name: values.name,
        description: values.description,
        category: values.category,
        subcategory: values.subcategory,
        image: imageUrl,
      };

      if (editingService) {
        await axios.put(
          `${API_BASE}/service/updateService/${editingService._id}`,
          payload
        );
        message.success("Service updated successfully");
      } else {
        await axios.post(`${API_BASE}/service/addService`, payload);
        message.success("Service added successfully");
      }

      fetchServices();
      closeModal();
    } catch (error) {
      console.error("Save Error:", error);
      message.error("Failed to save service.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      setLoading(true);
      await axios.delete(`${API_BASE}/service/deleteService/${id}`);
      message.success("Service deleted successfully");
      fetchServices();
    } catch (error) {
      console.error("Delete Error:", error);
      message.error("Failed to delete service.");
    } finally {
      setLoading(false);
    }
  };

  const openModal = (service = null) => {
    setModalState({ isVisible: true, editingService: service });

    if (service) {
      const selectedCat = categoryOptions.find((cat) => cat.value === service.category);
      setSelectedCategory(selectedCat);
      form.setFieldsValue({
        name: service.name,
        description: service.description,
        category: service.category,
        subcategory: service.subcategory,
        image: [
          {
            uid: "-1",
            name: "existing-image.jpg",
            status: "done",
            url: service.image,
          },
        ],
      });
    } else {
      setSelectedCategory(null);
      form.resetFields();
    }
  };

  const closeModal = () => {
    setModalState({ isVisible: false, editingService: null });
    form.resetFields();
    setSelectedCategory(null);
  };

  const antIcon = <LoadingOutlined style={{ fontSize: 40, color: "#fa8c16" }} spin />;

  const columns = [
    { title: "Service Name", dataIndex: "name", key: "name" },
    { title: "Description", dataIndex: "description", key: "description" },
    { title: "Category", dataIndex: "category", key: "category" },
    { title: "Subcategory", dataIndex: "subcategory", key: "subcategory" },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (text) =>
        text ? (
          <img src={text} alt="Service" style={{ width: "50px", borderRadius: "4px" }} />
        ) : (
          "No Image"
        ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space>
          <Button onClick={() => openModal(record)}>Edit</Button>
          <Button danger onClick={() => handleDelete(record._id)}>
            Delete
          </Button>
        </Space>
      ),
    },
  ];
const API_BASE = process.env.REACT_APP_API_BASE;

  return (
    <div className="p-4 bg-white rounded shadow">
      <h2 className="text-xl mb-4">Manage Services</h2>

      <Search
        placeholder="Search services"
        onChange={(e) => setSearchText(e.target.value)}
        style={{ marginBottom: "1rem" }}
      />

      <Button type="primary" onClick={() => openModal()} style={{ marginBottom: "1rem" }}>
        Add Service
      </Button>

      <Spin spinning={loading} indicator={antIcon} tip="Processing..." size="large">
        <Table
          columns={columns}
          dataSource={services.filter(
            (s) =>
              s.name.toLowerCase().includes(searchText.toLowerCase()) ||
              s.description.toLowerCase().includes(searchText.toLowerCase())
          )}
          rowKey="_id"
          pagination={{ pageSize: 10 }}
          scroll={{ x: "max-content", y: 500 }}
          sticky
        />
      </Spin>

      <Modal
        title={modalState.editingService ? "Edit Service" : "Add Service"}
        open={modalState.isVisible}
        onCancel={closeModal}
        onOk={handleSave}
        destroyOnClose
        confirmLoading={loading}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Service Name"
            rules={[{ required: true, message: "Please enter a name" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
            rules={[{ required: true, message: "Please enter a description" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="category"
            label="Category"
            rules={[{ required: true, message: "Please select a category" }]}
          >
            <Select
              placeholder="Select a category"
              onChange={(value) => {
                const selectedCat = categoryOptions.find((cat) => cat.value === value);
                setSelectedCategory(selectedCat);
                form.setFieldsValue({ subcategory: undefined });
              }}
              options={categoryOptions.map((cat) => ({
                label: cat.label,
                value: cat.value,
              }))}
            />
          </Form.Item>

          {selectedCategory && (
            <Form.Item
              name="subcategory"
              label="Subcategory"
              rules={[{ required: true, message: "Please select a subcategory" }]}
            >
              <Select
                placeholder="Select a subcategory"
                options={selectedCategory.subcategories.map((sub) => ({
                  label: sub,
                  value: sub,
                }))}
              />
            </Form.Item>
          )}

          <Form.Item
            name="image"
            label="Image"
            valuePropName="fileList"
            getValueFromEvent={(e) => e?.fileList || []}
            rules={[
              {
                required: !modalState.editingService,
                message: "Please upload an image!",
              },
            ]}
          >
            <Upload beforeUpload={() => false} listType="picture" maxCount={1}>
              <Button icon={<UploadOutlined />}>Upload</Button>
            </Upload>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ManageServices;
